<div class="modal-header border-0 pb-0" data-testid="deck-association-modal">
  <h5 class="modal-title">{{ i18n.t()["deckAssociation.title"] }}</h5>
  <button
    type="button"
    class="btn-close"
    [attr.aria-label]="i18n.t()['deckAssociation.close']"
    (click)="activeModal.dismiss()"
  ></button>
</div>

<div class="modal-body pt-2">
  <p class="text-muted mb-3">{{ i18n.t()["deckAssociation.description"] }}</p>

  @if (isLoading()) {
    <div class="text-muted py-3">{{ i18n.t()["deckAssociation.loading"] }}</div>
  } @else {
    <div
      class="deck-association-list"
      [attr.aria-label]="i18n.t()['deckAssociation.listAria']"
    >
      @for (deck of decks(); track deck.id) {
        <div
          class="deck-association-item"
          [attr.data-testid]="'deck-association-item-' + deck.id"
        >
          <div class="deck-association-details">
            <span class="deck-association-title">{{ deck.title }}</span>
            <span class="deck-association-mindmap">{{
              deck.mindMapTitle
            }}</span>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-sm deck-association-action"
            [disabled]="isSaving()"
            (click)="associate(deck.id)"
            [attr.data-testid]="'deck-association-submit-' + deck.id"
          >
            {{
              savingDeckId() === deck.id
                ? i18n.t()["deckAssociation.saving"]
                : i18n.t()["associateDeck"]
            }}
          </button>
        </div>
      } @empty {
        <div class="text-muted py-3">
          {{ i18n.t()["deckAssociation.empty"] }}
        </div>
      }
    </div>
  }

  @if (errorMessage) {
    <div class="alert alert-danger mt-3 mb-0" role="alert">
      {{ errorMessage }}
    </div>
  }
</div>

<div class="modal-footer border-0 pt-2">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
    {{ i18n.t()["deckAssociation.cancel"] }}
  </button>
</div>
